import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { type ReactNode } from "react";

type MetaRow = { label: string; value: ReactNode };

export function MetaSidebar({
  title,
  rows,
  ctaLabel,
  ctaHref,
  ctaPrompt,
}: {
  title: string;
  rows: MetaRow[];
  ctaLabel: string;
  ctaHref: string;
  ctaPrompt: string;
}) {
  return (
    <aside className="lg:sticky lg:top-28">
      <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-bg-elevated)] p-6 sm:p-7">
        <p className="font-mono-tech text-[0.7rem] uppercase tracking-[0.18em] text-[var(--color-text-tertiary)]">
          {title}
        </p>

        <dl className="mt-6 flex flex-col gap-5">
          {rows.map((row) => (
            <div key={row.label}>
              <dt className="text-[0.8125rem] text-[var(--color-text-tertiary)]">{row.label}</dt>
              <dd className="mt-1 font-display text-[1.0625rem] font-semibold leading-snug text-[var(--color-text-primary)]">
                {row.value}
              </dd>
            </div>
          ))}
        </dl>

        <div className="mt-7 border-t border-[var(--color-border)] pt-6">
          <p className="text-[0.9375rem] leading-relaxed text-[var(--color-text-secondary)]">
            {ctaPrompt}
          </p>
          <Link
            href={ctaHref}
            className="group mt-4 inline-flex items-center gap-2 rounded-full bg-[var(--color-primary)] px-5 py-2.5 text-sm font-medium text-white transition-colors hover:bg-[var(--color-primary-dark)]"
          >
            {ctaLabel}
            <ArrowRight aria-hidden className="size-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </div>
      </div>
    </aside>
  );
}
